import { render, staticRenderFns } from "./versionAlert.vue?vue&type=template&id=be9cf624&scoped=true&lang=html&"
import script from "./versionAlert.vue?vue&type=script&lang=js&"
export * from "./versionAlert.vue?vue&type=script&lang=js&"
import style0 from "./versionAlert.vue?vue&type=style&index=0&id=be9cf624&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9cf624",
  null
  
)

component.options.__file = "versionAlert.vue"
export default component.exports